'use client';
import type { PropsWithChildren, ReactNode } from 'react';

import { cn } from '../../../../utils/entry.js';

type DrawCardCloseTimeMobileProps = PropsWithChildren & {
  drawCardCloseTime: ReactNode;
  className?: string;
  childClassName?: string;
};

/**
 * Displays the draw close time with countdown for mobile view.
 *
 * @param props - Component props
 * @param props.drawCardCloseTime - The React node that displays the close time of the draw
 * @param props.children - Optional children to render inside the component
 * @param props.className - Optional class name for styling
 * @param props.childClassName - Optional class name for styling the child element
 * @returns A React node displaying the close time with countdown
 */
export default function DrawCardCloseTimeMobile({
  children,
  className,
  childClassName,
  drawCardCloseTime,
}: DrawCardCloseTimeMobileProps): ReactNode {
  return (
    <div
      className={cn('flex flex-col items-center justify-between lg:flex-row', className)}
      aria-label="Spelstopp"
      aria-live="off"
    >
      {children}
      <div className={cn('text-sm font-bold', childClassName)}>{drawCardCloseTime}</div>
    </div>
  );
}
